export default function ImportantInfo() {
  const infoItems = [
    {
      question: 'Sabe quais são as licenças necessárias ou autorizações específicas, mesmo para práticas exclusivamente online?',
      icon: 'ri-file-shield-2-line'
    },
    {
      question: 'Sabia que a comunicação à Ordem ou a entidades reguladoras é obrigatória, mesmo para serviços digitais?',
      icon: 'ri-government-line'
    },
    {
      question: 'Sabia que pode abrir um consultório físico ou apenas online, com agendamento, site e presença digital?',
      icon: 'ri-computer-line'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Informação Importante</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            O Que É Importante Que Saiba
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Questões essenciais que todo profissional de saúde deve conhecer antes de iniciar o seu negócio
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {infoItems.map((item, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-teal-600 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-teal-600 transition-colors">
                <i className={`${item.icon} text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <p className="text-base text-gray-700 leading-relaxed font-medium">
                {item.question}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-teal-50 border-l-4 border-teal-600 p-8 rounded-lg">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Não Sabe Por Onde Começar?
              </h3>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                A nossa equipa especializada está pronta para esclarecer todas as suas dúvidas e guiá-lo em cada etapa do processo. Desde licenças e autorizações até à implementação completa do seu projeto de saúde, estamos aqui para ajudar.
              </p>
              <button 
                onClick={() => {
                  const element = document.getElementById('reuniao');
                  if (element) {
                    const offset = 80;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth'
                    });
                  }
                }}
                className="bg-teal-600 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Fale Connosco
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}